import { theme } from '@geneo2-web/shared-ui';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';

const styles = {
  root: {
    height: '40px',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.04)',
    color: 'secondary.main',
    boxSizing: 'border-box',
    borderRadius: { xs: pxToRem(8), md: pxTovW(8) },
    padding: '0 15px',
    '& *': {
      fontSize: { xs: pxToRem(18), md: pxTovW(18) },
    },
    fontSize: { xs: pxToRem(18), md: pxTovW(18) },
  },
  flexBox: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
};
interface IProps {
  smallVariant?: boolean;
  largeVariant?: boolean;
  quantity: number;
  incrementClickHandler?: () => void;
  decrementClickHandler?: () => void;
  minQuantity?: number;
  maxQuantity?: number;
  disabled?: boolean;
  withBorder?: boolean;
  buttonText?: string;
  quantityText?: string;
  disableColor?: boolean;
}
export default function QuantityButton(props: IProps) {
  const {
    quantity,
    largeVariant,
    smallVariant,
    incrementClickHandler,
    decrementClickHandler,
    minQuantity,
    maxQuantity,
    disabled,
    withBorder,
    buttonText,
    quantityText,
    disableColor,
  } = props;

  const md = useMediaQuery(theme.breakpoints.up('md'));
  return !quantity ? (
    <Button
      sx={{
        width: largeVariant ? '150px' : smallVariant ? '90px' : '116px',
        ...styles.root,
        border: withBorder ? '1px solid #A8D3FC' : 'none',
      }}
      onClick={incrementClickHandler && incrementClickHandler}
      disabled={disabled || !maxQuantity}
    >
      <Typography
        variant="h3"
        color={disabled || !maxQuantity ? 'grey' : 'secondary.main'}
        fontWeight={600}
        fontSize={md ? `${pxTovW(16)}` : `${pxToRem(16)}`}
      >
        {buttonText || 'Add'}
      </Typography>
    </Button>
  ) : (
    <Box
      sx={{
        width: largeVariant ? '150px' : smallVariant ? '90px' : '116px',
        border: withBorder ? '1px solid #A8D3FC' : 'none',
        ...styles.flexBox,
        ...styles.root,
      }}
    >
      <Button
        sx={{
          height: '100%',
          fontSize: '30px !important',
          color:
            (disabled || !!(minQuantity && quantity <= minQuantity)) &&
            disableColor
              ? 'grey'
              : 'secondary.main',
        }}
        color="secondary"
        onClick={decrementClickHandler && decrementClickHandler}
        disabled={disabled || !!(minQuantity && quantity <= minQuantity)}
      >
        -
      </Button>
      <Typography
        variant="button"
        fontSize={md ? `${pxToRem(18)}` : `${pxToRem(18)}!important`}
        fontFamily="Poppins"
        fontWeight={600}
      >
        {quantity} {quantityText || ''}
      </Typography>
      <Button
        sx={{
          height: '100%',
          fontSize: '22px !important',
          color:
            (disabled || !!(maxQuantity && quantity >= maxQuantity)) &&
            disableColor
              ? 'grey'
              : 'secondary.main',
        }}
        color="secondary"
        onClick={incrementClickHandler && incrementClickHandler}
        disabled={disabled || !!(maxQuantity && quantity >= maxQuantity)}
      >
        +
      </Button>
    </Box>
  );
}
